module.exports = __webpack_public_path__ + "media/Images/section-mask-top-13d67a93dcbea4d4d2e8434981c16e90.svg";